module.exports = __webpack_public_path__ + "static/media/pc_icon_left_normal.d63f5354.svg";